import React from 'react';

export const HistoryItemMoreIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 9.33333C3 9.68696 3.14048 10.0261 3.39052 10.2761C3.64057 10.5262 3.97971 10.6667 4.33333 10.6667C4.68696 10.6667 5.02609 10.5262 5.27614 10.2761C5.52619 10.0261 5.66667 9.68696 5.66667 9.33333C5.66667 8.97971 5.52619 8.64057 5.27614 8.39052C5.02609 8.14048 4.68696 8 4.33333 8C3.97971 8 3.64057 8.14048 3.39052 8.39052C3.14048 8.64057 3 8.97971 3 9.33333Z"
      fill="currentColor"
    />
    <path
      d="M7.66797 9.33333C7.66797 9.68696 7.80844 10.0261 8.05849 10.2761C8.30854 10.5262 8.64768 10.6667 9.0013 10.6667C9.35492 10.6667 9.69406 10.5262 9.94411 10.2761C10.1942 10.0261 10.3346 9.68696 10.3346 9.33333C10.3346 8.97971 10.1942 8.64057 9.94411 8.39052C9.69406 8.14048 9.35492 8 9.0013 8C8.64768 8 8.30854 8.14048 8.05849 8.39052C7.80844 8.64057 7.66797 8.97971 7.66797 9.33333Z"
      fill="currentColor"
    />
    <path
      d="M12.332 9.33333C12.332 9.50843 12.3665 9.68181 12.4335 9.84358C12.5005 10.0053 12.5987 10.1523 12.7226 10.2761C12.8464 10.4 12.9934 10.4982 13.1551 10.5652C13.3169 10.6322 13.4903 10.6667 13.6654 10.6667C13.8405 10.6667 14.0138 10.6322 14.1756 10.5652C14.3374 10.4982 14.4844 10.4 14.6082 10.2761C14.732 10.1523 14.8302 10.0053 14.8972 9.84358C14.9642 9.68181 14.9987 9.50843 14.9987 9.33333C14.9987 9.15824 14.9642 8.98486 14.8972 8.82309C14.8302 8.66132 14.732 8.51434 14.6082 8.39052C14.4844 8.26671 14.3374 8.1685 14.1756 8.10149C14.0138 8.03449 13.8405 8 13.6654 8C13.4903 8 13.3169 8.03449 13.1551 8.10149C12.9934 8.1685 12.8464 8.26671 12.7226 8.39052C12.5987 8.51434 12.5005 8.66132 12.4335 8.82309C12.3665 8.98486 12.332 9.15824 12.332 9.33333Z"
      fill="currentColor"
    />
  </svg>
);

export const HistoryMenuDeleteIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.937 6.14746H10.187V7.64746H10.937H17.5417H18.2917V6.14746H17.5417H10.937ZM5.81439 9.08203H6.56439H21.9142H22.6642V10.582H21.9142H20.403V20.0888C20.403 21.0552 19.6195 21.8387 18.653 21.8388L9.82544 21.8389C8.85893 21.8389 8.07541 21.0554 8.07541 20.0889V10.582H6.56439H5.81439V9.08203ZM9.57541 10.582H18.903V20.0888C18.903 20.2268 18.7911 20.3388 18.653 20.3388L9.82542 20.3389C9.68735 20.3389 9.57541 20.227 9.57541 20.0889V10.582ZM11.7973 13.5986V17.2305H13.2973V13.5986H11.7973ZM15.1811 17.2305V13.5986H16.6811V17.2305H15.1811Z"
      fill="currentColor"
    />
  </svg>
);

export const HistoryMenuRenameIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3046 3.43412C12.6212 2.7507 11.5131 2.7507 10.8297 3.43411L3.00689 11.2569C2.67638 11.5874 2.49182 12.0364 2.49435 12.5038L2.5139 16.1183C2.51909 17.0774 3.29533 17.8536 4.25445 17.8588L7.86882 17.8783C8.33621 17.8808 8.78519 17.6962 9.11569 17.3657L16.9385 9.54292C17.6219 8.85951 17.6219 7.75147 16.9385 7.06805L13.3046 3.43412ZM11.8904 4.49477C11.988 4.39714 12.1463 4.39714 12.2439 4.49478L15.8779 8.12871C15.9755 8.22634 15.9755 8.38463 15.8779 8.48226L14.7779 9.58226L10.7904 5.59477L11.8904 4.49477ZM9.7297 6.65543L4.06755 12.3176C4.02033 12.3648 3.99397 12.4289 3.99433 12.4957L4.01388 16.1102C4.01462 16.2472 4.12551 16.3581 4.26253 16.3588L7.8769 16.3783C7.94368 16.3787 8.00781 16.3523 8.05503 16.3051L13.7172 10.6429L9.7297 6.65543Z"
      fill="currentColor"
    />
  </svg>
);

export const HistoryMenuFavoriteIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.82501 7.35V20.9459C7.82501 21.2687 8.14003 21.4975 8.44698 21.3976L13.5591 19.7343C13.8457 19.6411 14.1544 19.6411 14.4409 19.7343L19.553 21.3976C19.86 21.4975 20.175 21.2687 20.175 20.9459V7.35C20.175 6.82533 19.7497 6.4 19.225 6.4H8.77501C8.25034 6.4 7.82501 6.82533 7.82501 7.35Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const HistoryMenuUnfavoriteIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.82495 7.35V20.9459C7.82495 21.2687 8.13997 21.4975 8.44692 21.3976L13.5591 19.7343C13.8456 19.6411 14.1543 19.6411 14.4408 19.7343L19.553 21.3976C19.8599 21.4975 20.175 21.2687 20.175 20.9459V7.35C20.175 6.82533 19.7496 6.4 19.225 6.4H8.77495C8.25028 6.4 7.82495 6.82533 7.82495 7.35Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.6204 12.5073L13.5435 14.4304C13.6216 14.5085 13.7483 14.5085 13.8264 14.4304L17.0011 11.2556"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
